if (!customElements.get("cart-progress")) {
  customElements.define(
    "cart-progress",
    class CartProgress extends HTMLElement {
      moneyFormat = "${{amount}}";

      constructor() {
        super();
        this.freeShippingLimit = this.getAttribute("data-fs-limit");
        this.freeGiftLimit = this.getAttribute("data-fg-limit");
        this.cartMessage = this.querySelector("[data-message]");
        const moneyFormat = this.getAttribute("data-money-format");
        if (moneyFormat) {
          this.moneyFormat = this.getAttribute("data-money-format");
        }

        this.rate = window.Shopify.currency.rate;
        this.progress = this.querySelector("[data-progress]");
        this.progressAchieve = this.querySelector("[data-progress-achieve]");
        this.leftToSpendFS = this.querySelector("[data-left-to-spend-fs]");
        this.leftToSpendFG = this.querySelector("[data-left-to-spend-fg]");

        this.hasGift = this.dataset.hasGift == "true";

        this.cartTotalPrice = Number(this.getAttribute("data-cart-total-price"));
        if (isNaN(this.cartTotalPrice)) this.cartTotalPrice = 0;

        // console.log("hasGift",this.hasGift);
        if (this.cartMessage) {
          this.init();
        }
        this.render();
      }

      formatMoney(t, e) {
        "string" == typeof t && (t = t.replace(".", ""));
        let i = "";
        const n = /\{\{\s*(\w+)\s*\}\}/
          , o = e || "${{amount}}";
        function s(t, e = 2, i = ",", n = ".") {
          if (isNaN(t) || null == t)
            return 0;
          const o = (t = (t / 100).toFixed(e)).split(".");
          return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`) + (o[1] ? n + o[1] : "")
        }
        switch (o.match(n)[1]) {
          case "amount":
            i = s(t, 2);
            break;
          case "amount_no_decimals":
            i = s(t, 0);
            break;
          case "amount_with_comma_separator":
            i = s(t, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            i = s(t, 0, ".", ",")
        }
        return o.replace(n, i)
      }

      init() {
        this.cartFreeLimitShipping =
          Number(this.freeShippingLimit) * 100 * this.rate;
        this.cartFreeGiftLimit = Number(this.freeGiftLimit) * 100 * this.rate;
        this.shippingAmount = 0;
        // this.circumference = 28 * Math.PI; // radius - stroke * 4 * PI

        this.exchangeRateConversions(
          this.cartFreeLimitShipping,
          this.shippingAmount,
          this.leftToSpendFS
        );

        if (this.progress && this.progressAchieve) {
          this.cartBarProgress();
        }

        this.listen();
      }

      listen() {
        document.addEventListener(
          "theme:cart:change",
          function (event) {
            this.cart = event.detail.cart;
            this.render();
          }.bind(this)
        );
      }

      render() {
        const totalPrice = this.cartTotalPrice;
        this.freeMessageHandle(totalPrice);

        if (this.cart && this.cartTotalPrice) {
          // Build cart again if the quantity of the changed product is 0 or cart discounts are changed
        }
        this.shippingAmount = totalPrice;
        if (this.cartMessage) {
          this.updateProgress();
        }
      }

      freeMessageHandle(total) {
        // 判定处于是否免邮和赠品状态
        this.classList.toggle(
          "is-free-shipping",
          total > this.cartFreeLimitShipping
        );
        if (this.hasGift) {
          this.classList.toggle("is-free-gift", total > this.cartFreeGiftLimit);
        }
      }

      cartBarProgress(progress = null) {
        // 修改进度条
        if (progress != null) {
          this.progressAchieve.style.width = progress + "%";
        }
      }

      updateProgress() {
        // 计算百分比 更新进度
        let newPercentValue;

        if (this.hasGift) {
          newPercentValue = (this.shippingAmount / this.cartFreeGiftLimit) * 100;
        } else {
          newPercentValue = (this.shippingAmount / this.cartFreeLimitShipping) * 100;

        }

        //   更新免邮进度
        this.exchangeRateConversions(
          this.cartFreeLimitShipping,
          this.shippingAmount,
          this.leftToSpendFS
        );
        if (this.hasGift) {
          //   更新礼物进度
          this.exchangeRateConversions(
            this.cartFreeGiftLimit,
            this.shippingAmount,
            this.leftToSpendFG
          );
        }
        this.cartBarProgress(newPercentValue > 100 ? 100 : newPercentValue);
      }

      exchangeRateConversions(
        cartFreeLimitShipping,
        shippingAmount,
        leftToSpendEl
      ) {
        // 计算剩余金额
        const leftToSpend = theme.settings.currency_code_enabled
          ? this.formatMoney(
            cartFreeLimitShipping - shippingAmount,
            this.moneyFormat
          ) + ` ${theme.currencyCode}`
          : this.formatMoney(
            cartFreeLimitShipping - shippingAmount,
            this.moneyFormat
          );

        if (leftToSpendEl) {
          leftToSpendEl.innerHTML = leftToSpend.replace(".00", "");
        }
      }
    }
  );
}
